/**
 * Brazilian Portuguese (pt-BR) mappings for TeamStatsMenu
 */

export const teamStatsMenuPtBR = {
  "Game Explorer": "Explorador de Jogos",
  "Quick Game Explorer": "Explorador Rápido de Jogos",
  "Select Sport": "Selecionar Esporte",
  "Coming Soon": "Em Breve",
  "Close": "Fechar"
};